var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.88369,
    height: 116,
    viewBox: "0,0,122.88369,116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-178.55815,-122)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-paper-data": "{\"isPaintingLayer\":true}",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.96815,191.63c0.35,-2.91 -8.3,-14.06 -9.88,-19.4c-3.39,-5.38 -4.59,-13.94 -0.9,-19.63c1.47,-2.26 0.84,-4.22 0.84,-7.35c0,-31 54.27,-31 54.27,0c0,3.92 -0.89,4.84 1.22,7.93c3.55,5.15 1.73,14.29 -1.27,19.07c-1.93,5.61 -11,16.22 -10.37,19.4c0.57,15.89 -34,15.38 -33.91,0z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.70816,211.19c14.85,4.96 14.85,5.65 14.71,26.81h-49.41l13.91188,-36.63102c0.02197,-0.02312 0.04394,-0.04631 0.0659,-0.06955c0.15404,-0.064 0.27485,-0.13609 0.41158,-0.19991c6.32299,4.19628 13.14603,7.58615 20.31064,10.09047z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.55815,238c1.47,-19 -2.26,-18.21 13.65,-24.16c7.81591,-2.99451 15.30491,-6.7809 22.35,-11.3l13.6,35.46z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.31816,238h-14.76l3.73,-18.88h-1.94c-1.71859,-0.01091 -3.10909,-1.40141 -3.12,-3.12v-5c0.00549,-1.72085 1.39915,-3.11451 3.12,-3.12h11.31c1.72313,0 3.12,1.39687 3.12,3.12v5c0.00001,1.72475 -1.39526,3.12449 -3.12,3.13h-1.91z",
    fill: "#d9bca9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolo);
export default __webpack_public_path__ + "static/media/Solo.b4ab623b8f1948f326a07b3093d1137b.svg";
export { ForwardRef as ReactComponent };